exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".components-work-___noAccess__container___1Pq2_{-ms-flex-align:center;align-items:center;color:#fff;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;font-size:14px;-ms-flex-pack:center;justify-content:center}.components-work-___noAccess__container___1Pq2_ p{margin:0}.components-work-___noAccess__image___3tily{height:150px;margin-bottom:20px;opacity:.7;width:150px}.components-work-___noAccess__backBtn___3N0ca{cursor:pointer;margin-top:20px;width:auto}", ""]);

// exports
exports.locals = {
	"container": "components-work-___noAccess__container___1Pq2_",
	"image": "components-work-___noAccess__image___3tily",
	"backBtn": "components-work-___noAccess__backBtn___3N0ca"
};


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src2416834937/src/pobble-app/client/~/css-loader?importLoader=1&modules&localIdentName=[path]___[name]__[local]___[hash:base64:5]!/codebuild/output/src2416834937/src/pobble-app/client/~/postcss-loader!./components/work/noAccess.css
// module id = 463
// module chunks = 0